var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60012 19.8351L11.9181 11.2351H13.9461L17.9641 26.2231L19.4341 20.6231L20.4541 19.8231H24.2961L26.6141 11.2231H28.6521L30.9701 19.8231H37.6461C38.1222 18.3029 38.3689 16.7201 38.3781 15.1271C38.3781 8.96512 33.6281 3.98712 27.8021 3.98712C26.3251 4.00396 24.8679 4.32997 23.5245 4.94415C22.1811 5.55833 20.9812 6.44706 20.0021 7.55312C18.0821 5.40112 15.3101 3.98712 12.2561 3.98712C6.42612 3.99912 1.62012 8.97712 1.62012 15.1391C1.65114 16.7356 1.92079 18.3184 2.42012 19.8351H9.60012Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.122 21.9851H36.8C32.33 31.6011 20 37.8211 20 37.8211C20 37.8211 7.72801 31.6011 3.26001 21.9851H10.384L11.4 21.1851L12.928 15.5851L16.946 30.5751H18.982L21.3 21.9751H25.1L26.116 21.1751L27.586 15.5751L29.114 21.1751L30.122 21.9851Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/Pulse.919ebe9e1ac8ffc9edd97a8eb5a255d0.svg";
export { ForwardRef as ReactComponent };